export default __webpack_public_path__ + "img/pencil-box.9a09bf26.svg";